import type React from 'react';

export const getDataFromForm = <T>(event: React.FormEvent<HTMLFormElement>): T =>
    Object.fromEntries(new FormData(event.currentTarget)) as unknown as T;
